function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getValidElementProps } from '../utils/htmlValidProps';
var propTypes = {
  active: PropTypes.bool,
  activeHref: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  onItemClick: PropTypes.func,
  routerLink: PropTypes.bool,
  tabIndex: PropTypes.number,
  isActiveFunc: PropTypes.func,
  target: PropTypes.string,
  rel: PropTypes.string
};
var defaultProps = {
  active: false,
  name: '',
  tabIndex: 0,
  onItemClick: function onItemClick() {},
  routerLink: true,
  rel: null
};

var SubNavItem = /*#__PURE__*/function (_Component) {
  _inherits(SubNavItem, _Component);

  var _super = _createSuper(SubNavItem);

  function SubNavItem() {
    var _this;

    _classCallCheck(this, SubNavItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleItemSelected", function () {
      var _this$props = _this.props,
          href = _this$props.href,
          index = _this$props.index,
          onItemClick = _this$props.onItemClick;
      var info = {
        href: href,
        index: index
      };
      onItemClick(info);
    });

    _defineProperty(_assertThisInitialized(_this), "generateSubNavItemLink", function (classes, props) {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          href = _this$props2.href,
          tabIndex = _this$props2.tabIndex,
          isActiveFunc = _this$props2.isActiveFunc,
          routerLink = _this$props2.routerLink,
          target = _this$props2.target,
          rel = _this$props2.rel;
      var items;

      if (routerLink && href !== undefined) {
        items = /*#__PURE__*/React.createElement("li", {
          role: "menuitem"
        }, /*#__PURE__*/React.createElement(NavLink, _extends({
          to: href,
          className: classes
        }, props, {
          tabIndex: tabIndex,
          activeClassName: "subnav__item--active",
          onClick: _this.handleItemSelected,
          exact: true,
          isActive: isActiveFunc,
          target: target,
          rel: rel || target === '_blank' ? 'noopener noreferrer' : null
        }), name));
      } else if (href) {
        items = /*#__PURE__*/React.createElement("li", {
          role: "menuitem"
        }, /*#__PURE__*/React.createElement("a", _extends({
          href: href,
          className: classes
        }, props, {
          tabIndex: tabIndex,
          target: target,
          rel: rel || target === '_blank' ? 'noopener noreferrer' : null
        }), name));
      } else {
        items = /*#__PURE__*/React.createElement("li", {
          role: "menuitem",
          className: classes
        }, name);
      }

      return items;
    });

    return _this;
  }

  _createClass(SubNavItem, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          active = _this$props3.active;
      var restProps = getValidElementProps('a', this.props);
      var ntClass = classnames(_defineProperty({
        subnav__item: true,
        'subnav__item-skin': true,
        list: true,
        'hover-highlight--primary': true,
        'subnav__item--active': active
      }, className, className));
      var subNavItemLink = this.generateSubNavItemLink(ntClass, restProps);
      return /*#__PURE__*/React.createElement(React.Fragment, null, subNavItemLink);
    }
  }]);

  return SubNavItem;
}(Component);

SubNavItem.propTypes = propTypes;
SubNavItem.defaultProps = defaultProps;
SubNavItem.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleItemSelected",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "generateSubNavItemLink",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "classes",
      "type": null
    }, {
      "name": "props",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "SubNavItem",
  "props": {
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onItemClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "routerLink": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "rel": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "activeHref": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": ""
    },
    "index": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    },
    "isActiveFunc": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "target": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default SubNavItem;